import { User, NewsArticle, NewsArticlePost, NewsArticlePatch, PortalInformation } from "@infoland/iprova-api";
import { Store } from "vuex";
import { namespace as newsArticleNamespace } from "../modules/newsArticle/newsArticle";
import { NewsArticleRequest } from "../../types/newsArticles-request";
import * as Types from "../../types";
export class NewsArticleStore {
    private store: Store<any>;
    constructor(store: Store<any>) {
        this.store = store;
    }
    /** Gets the news articles */
    public get newsArticlesByPortalId(): NewsArticle[] {
        return this.store.getters[`${newsArticleNamespace}/newsArticlesByPortalId`];
    }
    /** Gets the news article */
    public get getNewsArticle(): NewsArticle {
        return this.store.getters[`${newsArticleNamespace}/newsArticle`];
    }
    /* Loads the news article */
    public async loadNewsArticlesByPortal(requestModel: NewsArticleRequest): Promise<NewsArticle[]> {
        return this.store.dispatch(`${newsArticleNamespace}/loadNewsArticlesByPortal`, requestModel);
    }

    public async loadNewsArticleAsync(newsArticleId: number, includePortals = false): Promise<NewsArticle> {
        const param: Types.NewsArticleGet = { newsArticleId, includePortals };
        return this.store.dispatch(`${newsArticleNamespace}/loadNewsArticleAsync`, param);
    }

    public async createNewsArticleAsync(newsArticleModel: NewsArticlePost): Promise<number | null> {
        return this.store.dispatch(`${newsArticleNamespace}/createNewsArticleAsync`, newsArticleModel);
    }
    public async saveNewsArticleAsync(id: number, newsArticleProps: NewsArticlePatch): Promise<boolean | null> {
        return this.store.dispatch(`${newsArticleNamespace}/saveNewsArticleAsync`, { id, newsArticleProps });
    }
    public async deleteArticleAsync(newsArticleId: number): Promise<boolean | null> {
        return this.store.dispatch(`${newsArticleNamespace}/deleteNewsArticleAsync`, newsArticleId);
    }
}
